import moment from "moment/moment";
import Star from "../Helpers/icons/Star";
import InputCom from "../Helpers/InputCom";
import LoaderStyleOne from "../Helpers/Loaders/LoaderStyleOne";
import StarRating from "../Helpers/StarRating";
import { Avatar, Rating } from "@mui/material";

export default function Reviews({
  comments,
  imageBaseUrl,
  rating,
  ratingHandler,
  name,
  nameHandler,
  email,
  emailHandler,
  phone,
  phoneHandler,
  message,
  messageHandler,
  reviewAction,
  hoverRating,
  hoverHandler,
  reviewLoading,
}) {
  return (
    <div className="review-wrapper w-full">
      <div className="w-full reviews mb-[60px]">
        {/* comments */}
        <div className="w-full comments mb-[60px]">
          {comments && comments.length === 0 && (
            <div className="bg-white px-10 py-12 flex flex-col items-center justify-center text-center">
              <svg className="w-16 h-16 text-qgray mb-4 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-3 3v-3z" />
              </svg>
              <p className="text-[18px] font-medium text-qblack mb-1">No Reviews Yet</p>
              <p className="text-[14px] text-qgray">Be the first to share your thoughts about this product.</p>
            </div>
          )}
          {comments &&
            comments.length > 0 &&
            comments.map((comment) => (
              <div
                key={comment.id}
                className="comment-item bg-white px-10 py-[32px] mb-2.5"
              >
                <div className="comment-author flex justify-between items-center mb-3">
                  <div className="flex space-x-3 items-center">
                    <div className="overflow-hidden">
                      <Avatar
                        src={imageBaseUrl + comment?.user_id + '/' + comment?.user_image}
                        alt={comment?.user_name}
                      />
                    </div>
                    <div>
                      <p className="text-[18px] font-medium text-qblack">
                        {comment?.user_name}
                      </p>
                      {/* <p className="text-[13px] font-normal text-qgray">
                        London,UK
                      </p> */}
                      <p className="text-[13px] font-normal text-qgray">
                        {moment(comment?.created_at).format('DD MMM YYYY')}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex">
                      {/* {Array.from(Array(comment?.rating), () => (
                        <span key={comment?.rating + Math.random()}>
                          <Star />
                        </span>
                      ))} */}
                      <Rating name="half-rating-read" defaultValue={comment?.rating} precision={0.5} readOnly />
                    </div>
                    <span className="text-[13px] font-normal text-qblack mt-1 inline-block">
                      ({comment.rating})
                    </span>
                  </div>
                </div>
                <div className="comment mb-[30px]">
                  <p className="text-[15px] text-qgray leading-7 text-normal">
                    {comment?.notes}
                  </p>
                </div>
                {comment.child_reviews &&
                  comment.child_reviews.length > 0 &&
                  comment.child_reviews.map((reply) => (
                    <div
                      key={reply.id}
                      className="sub-comment-item bg-white px-10 pt-[32px] border-t"
                    >
                      <div className="comment-author  mb-3">
                        <div className="flex space-x-3 items-center">
                          <div className="overflow-hidden">
                            <Avatar
                              src={imageBaseUrl + reply?.user_id + '/' + reply?.user_image}
                              alt={reply?.user_name}
                            />
                          </div>
                          <div>
                            <p className="text-[18px] font-medium text-qblack">
                              {reply.user_name}
                            </p>
                            <p className="text-[13px] font-normal text-qgray">
                              {moment(reply?.created_at).format('DD MMM YYYY')}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="comment mb-[30px]">
                        <p className="text-[15px] text-qgray leading-7 text-normal">
                          {reply.notes}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
        </div>
        {/* load comments */}
        {/* <div className="w-full flex justify-center">
          <button
            type="button"
            className="black-btn w-[300px] h-[50px] text-sm font-semibold"
          >
            Load More
          </button>
        </div> */}
      </div>
      {/* <div className="write-review w-full">
        <h1 className="text-2xl font-medium text-qblack mb-5">
          Write Your Reviews
        </h1>

        <div className="flex space-x-1 items-center mb-[30px]">
          <StarRating
            hoverRating={hoverRating}
            hoverHandler={hoverHandler}
            rating={rating}
            ratingHandler={ratingHandler}
          />
          <span className="text-qblack text-[15px] font-normal mt-1">
            ({rating}.0)
          </span>
        </div>

        <div className="w-full review-form ">
          <div className="sm:flex sm:space-x-[30px] items-center mb-5">
            <div className="sm:w-1/3 w-full">
              <InputCom
                label="name*"
                placeholder=""
                type="text"
                name="name"
                inputClasses="h-[50px]"
                value={name}
                inputHandler={nameHandler}
              />
            </div>
            <div className="sm:w-1/3 w-full mt-5 sm:mt-0">
              <InputCom
                label="Email*"
                placeholder=""
                type="email"
                name="name"
                inputClasses="h-[50px]"
                value={email}
                inputHandler={emailHandler}
              />
            </div>
            <div className="sm:w-1/3 w-full mt-5 sm:mt-0">
              <InputCom
                label="Phone Number*"
                placeholder=""
                type="text"
                name="name"
                inputClasses="h-[50px]"
                value={phone}
                inputHandler={phoneHandler}
              />
            </div>
          </div>
          <div className="w-full mb-[30px]">
            <h6 className="input-label text-qgray capitalize text-[13px] font-normal block mb-2 ">
              Message*
            </h6>
            <textarea
              value={message}
              onChange={messageHandler}
              name=""
              id=""
              cols="30"
              rows="3"
              className="w-full focus:ring-0 focus:outline-none p-6"
            ></textarea>
          </div>

          <div className="flex justify-end">
            <button
              onClick={reviewAction}
              type="button"
              className="black-btn w-[300px] h-[50px]  flex justify-center"
            >
              <span className="flex space-x-1 items-center h-full">
                <span className="text-sm font-semibold">Submit Review</span>
                {reviewLoading && (
                  <span className="w-5 " style={{ transform: "scale(0.3)" }}>
                    <LoaderStyleOne />
                  </span>
                )}
              </span>
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
}
